import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import DataGridSelectFormInput from '../input/DataGridSelect';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormFieldBase from './FieldBase';
import FormControl from '@material-ui/core/FormControl';
/**@param {import('./types').FinalFormFieldDataGridSelectProps} props */

var DataGridSelectFormField = function DataGridSelectFormField(_ref) {
  var _ref$input = _ref.input,
      name = _ref$input.name,
      value = _ref$input.value,
      onChange = _ref$input.onChange,
      meta = _ref.meta,
      label = _ref.label,
      formControlProps = _ref.formControlProps,
      id = _ref.id,
      dataType = _ref.dataType,
      margin = _ref.margin,
      rest = _objectWithoutProperties(_ref, ["input", "meta", "label", "formControlProps", "id", "dataType", "margin"]);

  var showError = (meta.submitError && !meta.dirtySinceLastSubmit || meta.error) && meta.touched;
  var style = {};

  if (rest && rest.style) {
    style = _objectSpread({}, rest.style);
  }

  if (label) style.marginTop = 16;
  return React.createElement(React.Fragment, null, React.createElement(FormControl, Object.assign({}, formControlProps, {
    error: showError,
    fullWidth: true,
    margin: margin
  }), React.createElement(DataGridSelectFormInput, Object.assign({}, rest, {
    viewProps: {
      style: style
    },
    name: name,
    value: value,
    onChange: onChange,
    dataType: dataType,
    id: id
  })), showError && React.createElement(FormHelperText, null, meta.error || meta.submitError)));
};

var smartInjectLabel = function smartInjectLabel(rest) {
  var label = rest.label;
  if (typeof label === 'undefined' || label) return true;else return false;
};

export var DataGridSelect = function DataGridSelect(_ref2) {
  var name = _ref2.name,
      rest = _objectWithoutProperties(_ref2, ["name"]);

  return React.createElement(FormFieldBase, Object.assign({
    injectLabel: smartInjectLabel(rest),
    name: name,
    label: name
  }, rest));
};
DataGridSelect.defaultProps = {
  component: DataGridSelectFormField,
  margin: 'normal'
};
export default DataGridSelectFormField;